import { render } from "./HeartRateMonitor.vue?vue&type=template&id=4859c34f&scoped=true"
import script from "./HeartRateMonitor.vue?vue&type=script&lang=js"
export * from "./HeartRateMonitor.vue?vue&type=script&lang=js"

import "./HeartRateMonitor.vue?vue&type=style&index=0&id=4859c34f&scoped=true&lang=scss"
import "./HeartRateMonitor.vue?vue&type=style&index=1&id=4859c34f&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4859c34f"]])

export default __exports__